import { lazy } from 'react';

export const RecoveryFormAsync = lazy(() => import('./RecoveryForm').then((m) => ({ default: m.RecoveryForm })));
